import { Tag, Typography } from 'antd';

/** 表格中展示逗号分隔标签 */
export function TagsCell({ value }: { value?: string }) {
  const parts = (value || '')
    .split(',')
    .map((t) => t.trim())
    .filter(Boolean);
  if (parts.length === 0) {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      {parts.map((t) => (
        <Tag key={t} style={{ marginInlineEnd: 0 }}>
          {t}
        </Tag>
      ))}
    </span>
  );
}
